<template>
  <div>
    <div class="panel text-left">
      <div :class="['loading-area', commissionsSaving ? 'loading' : '']">
        <div
          :class="['loading-area__content', commissionsSaving ? 'loading' : '']"
        >
          <div class="panel__header">
            <!--            <p>{{this.commission}}</p>-->
            <h3 class="panel__title">Commission Configuration</h3>
          </div>

          <div class="panel__content">
            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Tracking Type
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">If Vendor Name is chosen commissions will be awarded by the vendor name on a product. If Product Tag is chosen then commissions will be awarded by a tag look up starting with vendor_</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.tracking_type === 'Vendor Name'
                        ? 'active'
                        : '',
                    ]"
                    @click="chooseTracking('Vendor Name')"
                  >Vendor Name
                    <input
                      id="tracking-vendor-name"
                      class="hidden"
                      type="radio"
                      name="tracking"
                      value="vendor-name"
                    />
                  </label>

                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.tracking_type === 'Product Tag'
                        ? 'active'
                        : '',
                    ]"
                    @click="chooseTracking('Product Tag')"
                  >Product Tag
                    <input
                      id="tracking-product-tag"
                      class="hidden"
                      type="radio"
                      name="tracking"
                      value="product-tag"
                    />
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field" v-if="settings && settings.tracking_type === 'Product Tag'">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Product Tag Prefix
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">The product tag to look up for vendor association will use whatever is after the prefix chosen on the tag. For example: vendor_John Doe will appear as John Doe.</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <input
                    id="vendor_tag"
                    class="medium-input"
                    name="product-tag-prefix"
                    type="text"
                    :value="this.$store.state.metas.vendor_product_tag_prefix !== undefined ? this.$store.state.metas.vendor_product_tag_prefix
                        .meta_value : ''"
                    placeholder="vendor_"
                  />
                </div>
              </div>
            </div>
            <hr/>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Calculation Type
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">If flat rate is chosen then the commission will use the cost per item field in shopify.</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <label
                    :class="[
                      'radio-choice',
                      settings && !settings.use_cost_per_item ? 'active' : '',
                    ]"
                    @click="chooseCalculation('percentage')"
                  >Percentage
                    <input
                      id="calculation-percentage"
                      class="hidden"
                      type="radio"
                      name="calculation"
                      value="percentage"
                    />
                  </label>

                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.use_cost_per_item ? 'active' : '',
                    ]"
                    @click="chooseCalculation('flat_rate')"
                  >Flat Rate
                    <input
                      id="calculation-flat-rate"
                      class="hidden"
                      type="radio"
                      name="calculation"
                      value="flat-rate"
                    />
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Global Commission
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">The global commission percentage will be used if no other settings are set such as vendor percentage, product type commissions, or not using flat rate. Example: 10%</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <div class="grid-x align-middle">
                    <div class="cell shrink">
                      <input
                        id="global-commission"
                        class="short-input"
                        name="global-comission"
                        type="text"
                        v-bind:placeholder="30"
                        v-bind:value="this.settings.global_commission"
                      />
                    </div>
                    <div class="cell shrink">
                      <div style="padding-left: 5px;">%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label>Discount Responsibility
                    <span class="css-tooltip">
                    <i class="fas fa-question-circle"></i>
                    <span class="css-tooltip__text">The party responsible for any applied product discounts</span></span></label>
                </div>

                <div class="cell auto">
                  <label :class="[discount === 'vendor' ? 'active' : '', 'radio-choice']"
                         for="discount-vendor" @click="changeDiscount('vendor')">Vendor
                    <input id="discount-vendor" class="hidden" type="radio"
                           name="discount" value="vendor"
                           :checked="discount === 'vendor' ? 'checked' : ''">
                  </label>

                  <label :class="[discount === 'store' ? 'active' : '', 'radio-choice']"
                         for="discount-store" @click="changeDiscount('store')">Store
                    <input id="discount-store" class="hidden" type="radio"
                           name="discount-store" value="store"
                           :checked="discount === 'store' ? 'checked' : ''">
                  </label>

                  <label :class="[discount === 'equal' ? 'active' : '', 'radio-choice']"
                         for="discount-equal" @click="changeDiscount('equal')">Equal
                    <input id="discount-equal" class="hidden" type="radio"
                           name="discount-equal" value="equal"
                           :checked="discount === 'equal' ? 'checked' : ''">
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label>Discount Calculation
                    <span class="css-tooltip">
                    <i class="fas fa-question-circle"></i>
                    <span class="css-tooltip__text">Controls when the line-item discount is subtracted during commission calculation. Select an option to see how it works.</span></span>
                  </label>
                </div>

                <div class="cell auto">
                  <label :class="[discountTiming === 'after' ? 'active' : '', 'radio-choice']"
                         for="discount-timing-after" @click="setDiscountTiming('after')">After applying the rate
                    <input id="discount-timing-after" class="hidden" type="radio"
                           name="discount-timing" value="after"
                           :checked="discountTiming === 'after' ? 'checked' : ''">
                  </label>

                  <label :class="[discountTiming === 'before' ? 'active' : '', 'radio-choice']"
                         for="discount-timing-before" @click="setDiscountTiming('before')">Before applying the rate
                    <input id="discount-timing-before" class="hidden" type="radio"
                           name="discount-timing" value="before"
                           :checked="discountTiming === 'before' ? 'checked' : ''">
                  </label>

                  <div class="grid-x align-middle" v-if="discountTiming === 'before'" style="margin-top: 8px;">
                    <div class="cell shrink">
                      <checkbox @check="toggleFlatRateDeduct" :active="flatRateDeduct"></checkbox>
                    </div>
                    <div class="cell auto" style="padding-left: 8px;">
                      <label style="margin: 0;">Also deduct from flat-rate / cost-per-item commissions
                        <span class="css-tooltip">
                          <i class="fas fa-question-circle"></i>
                          <span class="css-tooltip__text css-tooltip__text--end">By default, deducting the discount "before" the rate only affects percentage commissions; flat-rate / cost-per-item commissions keep their full amount (legacy behavior). Enable this to also subtract the vendor's discount share from flat-rate commissions.</span>
                        </span>
                      </label>
                    </div>
                  </div>

                  <p v-if="discountTiming === 'after'"><small>Commission is calculated on the full price, then the vendor's share of the discount is subtracted. <em>Example</em> (a $100 item with a $10 discount {{ discountShareLabel }}): $100 × 80% = $80; $80 − ${{ vendorSharePct }} = <strong>${{ standardExampleAmount }} commission</strong>. Flat-rate / cost-per-item commissions also have the discount subtracted.</small></p>
                  <p v-else-if="!flatRateDeduct"><small>The vendor's share of the discount is subtracted from the price before applying the rate. <em>Example</em> (a $100 item with a $10 discount {{ discountShareLabel }}): ($100 − ${{ vendorSharePct }}) × 80% = <strong>${{ pctOnlyExampleAmount }} commission</strong>. Note: For Flat Rate / Cost-per-item commissions, the discount is <strong>not</strong> deducted (legacy behavior) — enable the checkbox above to change this.</small></p>
                  <p v-else><small>The vendor's share of the discount is subtracted from the price before applying the rate, and is also subtracted from flat-rate commissions. <em>Example</em> (a $100 item with a $10 discount {{ discountShareLabel }}): percentage — ($100 − ${{ vendorSharePct }}) × 80% = <strong>${{ pctOnlyExampleAmount }}</strong>; flat-rate — a $156 commission with a $52 line discount becomes $156 − ${{ vendorShareFlat }} = <strong>${{ flatRateExampleAmount }} commission</strong>.</small></p>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell large-4">
                  <label>Calculate All Vendors by Profit
                    <span class="css-tooltip">
                    <i class="fas fa-question-circle"></i>
                    <span class="css-tooltip__text">If using a percentage based commission this will take the rate by the sale_price minus the cost_per_item for all vendor commissions calculations. You can turn this on per vendor from the vendor profile page.</span></span>
                  </label>
                </div>

                <div class="cell auto">
                  <checkbox @check="enableCalculateByProfit"
                            :active="metas.consignment_calculate_by_profit ? metas.consignment_calculate_by_profit.meta_value : false"></checkbox>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Date to Start Tracking Commissions
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">Commissions for orders before this date will not display or calculate on the vendor.</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <datepicker :id="'end-date'" class="medium-input"
                              :format="dateFormat"
                              :clear-button="true"
                              :placeholder="'Dec 31, 2099'"
                              :open-date="new Date(commissionDate)"
                              :value="commissionDate"
                              @cleared="commissionDateSelected"
                              @selected="commissionDateSelected"></datepicker>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Ignore Order Tags
                    <span class="css-tooltip">
                      <i class="fas fa-question-circle"></i>
                      <span class="css-tooltip__text">Orders that contain any of these tags will not award commission.</span>
                    </span>
                  </label>
                </div>

                <div class="cell auto">
                  <input
                    id="order-tags"
                    class="medium-input"
                    name="order-tags"
                    type="text"
                    :value="this.order_tags !== undefined ? this.order_tags : ''"
                    placeholder="influencer,affiliate..."
                  />

                  <p><small>Comma seperated list.</small></p>
                </div>
              </div>
            </div>
          </div>

          <div class="text-success-color text-right" v-if="success">
            Settings have been saved.
          </div>

          <div class="text-alert-color text-right" v-if="error">
            There was an error saving. Please try again later.
          </div>

          <div class="panel__footer text-right">
            <button @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>

    <productTypes></productTypes>
  </div>
</template>

<script>
import client from '@/mixins/client'
import productTypes from '@/pages/settings/productTypes'
import Commissions from '../vendors/sections/commissions'
import checkbox from '@/globals/checkbox'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'settingsCommissions',
  mixins: [client],
  components: {
    Commissions,
    checkbox,
    productTypes,
    Datepicker
  },
  data: function () {
    return {
      commissionsSaving: false,
      success: false,
      error: false,
      commissionDate: '',
      discount: '',
      discountTiming: 'after',
      flatRateDeduct: false,
      discountSettingOriginal: 'after|false',
      order_tags: '',
      commission: []
    }
  },
  methods: {
    changeDiscount (choice) {
      this.discount = choice
    },
    dateFormat (date) {
      return moment(date).format('MMM D, YYYY')
    },
    commissionDateSelected (date) {
      this.commissionDate = date
    },
    enableCalculateByProfit () {
      this.metas.consignment_calculate_by_profit.meta_value = !this.metas.consignment_calculate_by_profit.meta_value
    },
    setDiscountTiming (mode) {
      this.discountTiming = mode
      if (mode === 'after') {
        // Discount subtracted after the rate; flat-rate lines always deduct, so flat apply is a no-op.
        this.flatRateDeduct = false
      }
      this.syncDiscountMetas()
    },
    toggleFlatRateDeduct () {
      this.flatRateDeduct = !this.flatRateDeduct
      this.syncDiscountMetas()
    },
    syncDiscountMetas () {
      const preDiscount = this.discountTiming === 'before'
      const flatRateApply = preDiscount && this.flatRateDeduct
      this.metas.consignment_discount_pre_percentage.meta_value = preDiscount
      this.metas.consignment_flat_rate_apply_discount.meta_value = flatRateApply
    },
    async saveCommissions () {
      let commission = document
        .getElementById('global-commission')
        .value.trim()
      // The Product Tag Prefix input is only rendered when tracking by Product Tag;
      // when it's hidden, keep the existing stored prefix instead of reading the DOM.
      const vendorTagEl = document.getElementById('vendor_tag')
      let vendorTag = vendorTagEl
        ? vendorTagEl.value.trim()
        : (this.$store.state.metas.vendor_product_tag_prefix ? this.$store.state.metas.vendor_product_tag_prefix.meta_value : '')
      let orderTags = document.getElementById('order-tags').value.trim()

      this.order_tags = orderTags

      // let date = document.getElementById('date_picker').value

      if (commission === '') {
        commission = this.settings.global_commission
      }

      let updateCommissions = false

      const discountSetting = this.discountTiming + '|' + this.flatRateDeduct
      if (this.$store.state.settings.global_commission !== parseFloat(commission) || this.discount !== this.appSettings.discount_share || discountSetting !== this.discountSettingOriginal) {
        updateCommissions = true
      }

      this.$store.state.settings.global_commission = commission

      this.$store.state.metas.vendor_product_tag_prefix.meta_value = vendorTag

      await this.$store.dispatch(
        'updateMeta',
        this.metas.vendor_product_tag_prefix
      )

      await this.$store.dispatch(
        'updateMeta',
        this.metas.consignment_discount_pre_percentage
      )

      await this.$store.dispatch(
        'updateMeta',
        this.metas.consignment_flat_rate_apply_discount
      )

      await this.$store.dispatch(
        'updateMeta',
        this.metas.consignment_calculate_by_profit
      )

      if (this.commissionDate !== undefined && this.commissionDate !== null && this.commissionDate !== '') {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: moment(this.commissionDate).format('YYYY-MM-DDT00:00:00')
          }
        )
      } else {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: null
          }
        )
      }

      await this.$store.dispatch(
        'updateAppSettings', {
          discount_share: this.discount
        }
      )

      await this.$store.dispatch(
        'updateAppSettings', {
          ignore_order_tags: this.order_tags
        }
      )

      await this.request('put', '/settings/settings/' + this.$store.state.settings.id + '/retrieve-update/', {
        tracking_type: this.settings.tracking_type,
        global_commission: commission,
        use_cost_per_item: this.settings.use_cost_per_item
      })

      if (updateCommissions) {
        await this.request('get', '/orders/calculate-commissions/').then(response => {

        })
      }

      // await this.request('get', '/orders/calculate-commissions/').then(response => {
      //
      // })

      this.success = true
      this.commissionsSaving = false
    },
    save () {
      this.commissionsSaving = true
      this.saveCommissions()
    },
    chooseTracking (tracking) {
      this.settings.tracking_type = tracking
    },
    chooseCalculation (calcType) {
      if (calcType === 'flat_rate') {
        this.settings.use_cost_per_item = true
      }
      if (calcType === 'percentage') {
        this.settings.use_cost_per_item = false
      }
    }
  },
  computed: {
    appSettings () {
      return this.$store.state.appSettings
    },
    settings () {
      return this.$store.state.settings
    },
    metas () {
      return this.$store.state.metas
    },
    // Vendor's share of the example $10 discount, given current Discount Responsibility.
    vendorSharePct () {
      if (this.discount === 'equal') return 5
      if (this.discount === 'store') return 0
      return 10
    },
    // Vendor's share of the example $52 discount on the flat-rate scenario.
    vendorShareFlat () {
      if (this.discount === 'equal') return 26
      if (this.discount === 'store') return 0
      return 52
    },
    discountShareLabel () {
      if (this.discount === 'equal') return 'split equally'
      if (this.discount === 'store') return 'absorbed by the store'
      return 'absorbed by the vendor'
    },
    standardExampleAmount () {
      // $100 × 80% − vendor's share of $10
      return 80 - this.vendorSharePct
    },
    pctOnlyExampleAmount () {
      // ($100 − vendor's share) × 80%
      return (100 - this.vendorSharePct) * 0.8
    },
    flatRateExampleAmount () {
      // $156 flat − vendor's share of $52
      return 156 - this.vendorShareFlat
    }
  },
  created () {
    this.commissionDate = this.appSettings.commission_start_date
    this.discount = this.appSettings.discount_share
    this.order_tags = this.appSettings.ignore_order_tags

    const preDiscount = this.metas
      && this.metas.consignment_discount_pre_percentage
      && this.metas.consignment_discount_pre_percentage.meta_value === true
    const flatRateApply = this.metas
      && this.metas.consignment_flat_rate_apply_discount
      && this.metas.consignment_flat_rate_apply_discount.meta_value === true
    this.discountTiming = preDiscount ? 'before' : 'after'
    this.flatRateDeduct = preDiscount && flatRateApply
    this.discountSettingOriginal = this.discountTiming + '|' + this.flatRateDeduct
  }
}
</script>

<style lang="scss">
@import "../../styles/variables";
@import "../../styles/mixins";
</style>



// WEBPACK FOOTER //
// src/pages/settings/commissions.vue